import { presenceCost, validate } from '@/core/tools'
const constraints = {
    from: { presence: presenceCost },
    to: { presence: presenceCost },
}

export const validateRequirements = (data: any) => {
    return validate<any>(data, constraints)
}
